import React from 'react';
import AvgBasketSizeChart from '../AvgBasketSizeChart';
import CompletedVsCancelledOrderChart from '../CompletedVsCancelledOrderChart';
import GrossVsLostRevenueChart from '../GrossVsLostRevenueChart';
import PerformanceSummaryCard from '../PerformanceSummary/PerformanceSummaryCard';
import PaymentMethodAnalytics from '../Tables/PaymentMethodAnalytics';

const Sales = () => (
  <div className="flex flex-col gap-y-4">
    <PerformanceSummaryCard />
    <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
      <GrossVsLostRevenueChart />
      <CompletedVsCancelledOrderChart />
    </div>
    <AvgBasketSizeChart />
    <PaymentMethodAnalytics />
  </div>
);

export default Sales;
